import { Holiday } from "@agent-ds/shared/interfaces";
import { MasterApiService } from "@agent-ds/shared/services";
import { Component, OnInit } from "@angular/core";
import * as moment from "moment";

interface HolidayRow {
  date: string;
}

@Component({
  selector: "ag-settings-holiday-management-page",
  templateUrl: "./settings-holiday-management-page.component.html",
  styleUrls: ["./settings-holiday-management-page.component.scss"]
})
export class SettingsHolidayManagementPageComponent implements OnInit {
  minDate: string;
  holidays: HolidayRow[] = [];
  rowErrors: string[][] = [];

  constructor(readonly masterApiService: MasterApiService) {}

  ngOnInit(): void {
    this.loadHolidays();
    this.minDate = moment()
      .utcOffset(9)
      .startOf("day")
      .format("YYYY-MM-DD");
  }

  get showTable(): boolean {
    return this.holidays.length > 0;
  }

  addHoliday(): void {
    this.holidays.push({ date: "" });
  }

  removeHoliday(index: number): void {
    this.holidays.splice(index, 1);
  }

  update(): void {
    this.rowErrors = this.holidays.map((_, index) =>
      this.computeRowErrors(index)
    );
    const hasErrors = this.rowErrors.some(errors => errors.length > 0);
    if (hasErrors) {
      return;
    }

    const params = this.holidays.map(holiday => ({
      date: new Date(holiday.date).toISOString()
    }));
    this.masterApiService.createHoliday(params).subscribe(() => {
      this.loadHolidays();
    });
  }

  private computeRowErrors(index: number): string[] {
    const row = this.holidays[index];
    const trimmedDate = ((row && row.date) || "").trim();
    const errors: string[] = [];

    if (!trimmedDate) {
      errors.push("日付を入力してください。");
      return errors;
    }

    const isDuplicate = this.holidays.some((other, otherIndex) => {
      if (otherIndex === index) {
        return false;
      }
      return (other.date || "").trim() === trimmedDate;
    });

    if (isDuplicate) {
      errors.push("同じ日付が重複しています。");
    }

    return errors;
  }

  getRowErrors(index: number): string[] {
    return this.rowErrors[index] || [];
  }

  private loadHolidays(): void {
    this.masterApiService.getHolidays().subscribe((holidays: Holiday[]) => {
      this.holidays = holidays.map(holiday => ({
        date: holiday.date
      }));
      this.rowErrors = [];
    });
  }
}
